var Alberta = "Alberta";
var Manitoba = "Manitoba";
var Nunavut = "Nunavut";
var Ontario = "Ontario";
var Quebec = "Quebec";
var Saskatchewan = "Saskatchewan";
var Yukon = "Yukon";
var CAStates = {
	Alberta: Alberta,
	"British Columbia": "British Columbia",
	Manitoba: Manitoba,
	"New Brunswick": "New Brunswick",
	"Newfoundland and Labrador": "Newfoundland và Labrador",
	"Northwest Territories": "Lãnh thổ Tây Bắc",
	"Nova Scotia": "Nova Scotia",
	Nunavut: Nunavut,
	Ontario: Ontario,
	"Prince Edward Island": "Đảo Hoàng tử Edward",
	Quebec: Quebec,
	Saskatchewan: Saskatchewan,
	Yukon: Yukon
};

export { Alberta, Manitoba, Nunavut, Ontario, Quebec, Saskatchewan, Yukon, CAStates as default };
